import script from "./BidViewAuctionInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewAuctionInfo.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewAuctionInfo.vue?vue&type=style&index=0&id=0d1f6b99&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1f6b99"]])

export default __exports__